import type { Ref } from 'vue';
import type { HekateDisplayField, HekateDisplayForm } from '@onshape/www-inertia';
import { CAD_PLAN_ID, FieldHtmlNameUtil, Trans } from '@onshape/www-inertia';
import ExternalUtil from '../../../../ExternalUtil';
import CommonPreFilledProgressiveProfile from './CommonPreFilledProgressiveProfileDefinition';
import RedirectUtil from '../../../../util/RedirectUtil';

/** Only show fields that can't be sso filled, redirect to login if the user is not logged in  */
export default class EducatorUpgradeProgressiveProfile extends CommonPreFilledProgressiveProfile {
  public override async realtimeBranchModifications({
    formDefinition,
  }: {
    formDefinition: Ref<HekateDisplayForm>;
  }): Promise<void> {
    super.realtimeBranchModifications({ formDefinition });

    const planId = ExternalUtil.findDisplayFieldOrThrow({
      formDefinition,
      fieldName: FieldHtmlNameUtil.planId,
    });
    planId.val = CAD_PLAN_ID.EDU_EDUCATOR as string;
    const isProUpgrade = ExternalUtil.findDisplayFieldOrThrow({
      formDefinition,
      fieldName: FieldHtmlNameUtil.isProUpgrade,
    });
    isProUpgrade.val = 'true';
    const whatIsYourExperience = ExternalUtil.findDisplayFieldOrThrow({
      formDefinition,
      fieldName: FieldHtmlNameUtil.whatIsYourExperience,
    });
    whatIsYourExperience.val = 'educator';

    const { getInitParam } = useWwwLocation();
    const isRedirectDisabled = getInitParam('disable-redirect');
    if (isRedirectDisabled) {
      return;
    }

    // submit should only be enabled if the user is logged in to the product
    const submit = ExternalUtil.findDisplayFieldOrThrow({
      formDefinition,
      fieldName: FieldHtmlNameUtil.submit,
    });
    submit.isDisabled = true;

    const firstName = ExternalUtil.findDisplayFieldOrThrow({
      formDefinition,
      fieldName: FieldHtmlNameUtil.firstName,
    });
    const lastName = ExternalUtil.findDisplayFieldOrThrow({
      formDefinition,
      fieldName: FieldHtmlNameUtil.lastName,
    });
    const email = ExternalUtil.findDisplayFieldOrThrow({
      formDefinition,
      fieldName: FieldHtmlNameUtil.email,
    });

    const toHide: HekateDisplayField[] = [firstName, lastName, email];
    toHide.forEach((field) => {
      field.componentName = 'hidden-field';
    });

    const sso = await ExternalUtil.sso.getSsoData();

    // if not logged in show error message and redirect to sign in
    if (!sso) {
      ExternalUtil.scrollToTopOfForm({ formId: formDefinition.value.id });
      formDefinition.value.errorMessages.push({
        message: Trans.byKey('mustBeLoggedIn'),
      });
      RedirectUtil.redirectToLogin({ delay: 3000, returnTo: 'upgrade-educator' });
      return;
    }

    const canUpgrade =
      sso.currentUserData.ownPlanGroup === 'Free' ||
      sso.currentUserData.ownPlanGroup === 'EDU Standard';

    if (!canUpgrade) {
      const msg = Trans.byKey('educatorNoUpgrade');
      formDefinition.value.errorMessages.push({ message: msg });

      return;
    }

    submit.isDisabled = false;
    firstName.val = sso.firstName;
    lastName.val = sso.lastName;
    email.val = sso.email;
  }
}
